
const styles = (theme) => ({
  root: {
    '& .k-grid': {
      '& td.boolean-cell': {
        textAlign: 'center',
        padding: 0
      },
      '& td.badge-cell': {
        textAlign: 'center',
        padding: 0
      },
      '& td.money-cell': {
        textAlign: 'right'
      },
      '& td.action-cell': {
        textAlign: 'center',
        cursor: 'default',
        '& button.delete-button': {
          cursor: 'pointer',
          '@global': {
            i: {
              position: 'relative',
              top: -1,
              fontSize: 18
            }
          }
        },
      }
    },
    '& col.k-sorted': {
      backgroundColor: theme.grid.filteredColumn.backgroundColor
    },
    '& .k-alt': {
      backgroundColor: theme.grid.alternativeRow.backgroundColor
    },
    '& .k-grid td': {
      borderWidth: '0 0 1px 1px'
    }
  },
  withoutFilter: {
    '& .k-header': {
      backgroundColor: theme.grid.withoutFilter.backgroundColor
    },
    '& .k-grid-header': {
      backgroundColor: theme.grid.withoutFilter.backgroundColor
    },
    '& .k-grid-pager': {
      backgroundColor: theme.grid.withoutFilter.backgroundColor
    }
  },
  withActiveFilter: {
    '& .k-header': {
      backgroundColor: theme.grid.activeFilter.backgroundColor
    },
    '& .k-grid-header': {
      backgroundColor: theme.grid.activeFilter.backgroundColor
    },
    '& .k-grid-pager': {
      backgroundColor: theme.grid.activeFilter.backgroundColor
    }
  },
  titleCheckbox: {
    right: -4,
    padding: 0
  },
  totalCheckedItems: {
    position: 'absolute',
    left: 10,
    top: 2,
    cursor: 'pointer'
  },
  toolbar: {
    float: 'right',
    '@global': {
      button: {
        fontSize: 12,
        backgroundColor: theme.palette.primary.main,// '#229EEC',
        color: theme.palette.primary.contrastText, //'#fff',
        height: 25,
        marginLeft: '15px !important',
        padding: 0
      }
    }
  }
})

export {
  styles
}
